
define("json!gigaset_shoppingcodes/handles/gigaset_shoppingcodes.json", function(){ return {
	"default": [
		"gigaset_shoppingcodes/components/form"
	]
};});

